import React from "react";

import Header from "./components/Header";
import Calculator from "./components/Calculator";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      <Header />
      <Calculator />
      <Footer />
    </>
  );
}

export default App;
